import {Component, effect, OnInit, Signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RecaptchaLoaderService, ReCaptchaV3Service} from 'ng-recaptcha-2';
import {LookupController} from 'src/app/domain/presenter/controller/lookup.controller';
import {map} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';
import {LookupViewModel} from 'src/app/domain/presenter/viewmodel/lookup-view.model';
import {LookupService} from 'src/app/shared/services/lookup-service.service';
import {CommonModule} from '@angular/common';
import {ActivitySpinnerComponent} from 'src/app/shared/components/activity-spinner/activity-spinner.component';
import {VehicleBrand} from '../../domain/core/vehicle-brand.model';

@Component({
  selector: 'app-lookup',
  templateUrl: './lookup.component.html',
  providers: [
    ReCaptchaV3Service,
    RecaptchaLoaderService
  ],
  imports: [CommonModule, ActivitySpinnerComponent]
})
export class LookupComponent implements OnInit {
  favIcon: HTMLLinkElement = document.querySelector('#favIcon');
  controller: LookupController
  vm$: Signal<LookupViewModel>
  viewModel = new LookupViewModel()

  constructor(
    private route: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
    private lookupService: LookupService,
    private router: Router
  ) {
    // This is on purpose not injected , so the domain layer is free of angular references.
    this.controller = new LookupController({
      brandString: this.route.params.pipe(map((params) => params['brand'])),
      recaptchaToken: recaptchaV3Service.execute('token'),
      lookup: lookupService.lookup.bind(lookupService),
    });

    this.vm$ = toSignal(this.controller.viewModel$)

    // Warten auf ersten sinnvollen Wert und dann Favicon setzen
    effect(() => {
      const viewModel = this.vm$();
      const favicon = viewModel?.brand?.favicon;
      if (favicon && this.favIcon) {
        this.favIcon.href = `/assets/images/${favicon}`;
      }
    });

  }

  ngOnInit() {
    this.setBrandFromUrl();
    this.controller.onInit();
  }

  didClickLookupButton() {
    this.controller.lookup()
  }

  setEmail(email: string) {
    this.controller.setEmail(email)
  }

  private setBrandFromUrl(): void {
    const brandFromParams =
      this.route.snapshot.paramMap.get('brand') ||
      this.route.parent?.snapshot.paramMap.get('brand');

    const brandStr = (brandFromParams ?? this.router.url.toLowerCase())
      .split('/')
      .find((seg) => seg === 'toyota' || seg === 'lexus');

    if (brandStr === 'lexus') {
      this.viewModel.brand = VehicleBrand.LEXUS;
    } else if (brandStr === 'toyota') {
      this.viewModel.brand = VehicleBrand.TOYOTA;
    }
  }
}
